<template>
  <div
    :ref="id"
    :class="['toast-notification', `toast-notification-${size}`]"
    :style="`--toast-duration: ${duration}s; background: ${toastColor.background}`"
  >
    <div class="body">
      <div class="content">
        <div class="content__message">
          <Icon
            value="info"
            :ui="{ icon: 'content__icon' }"
            :style="`color: ${toastColor.color}`"
          />
          <p>{{ message }}</p>
        </div>
        <Icon
          value="tiny-close"
          :ui="{ icon: 'content__icon' }"
          :style="`color: #8c8c8c`"
          @click.prevent="close"
        />
        <div v-if="details" ref="detailsRef" class="content__icon" @click.stop>
          <div class="content__details-btn" @click.stop="onDetailsClick">
            Подробнее
          </div>
          <p
            v-if="isDetailsActive"
            class="content__details-text"
            @mousedown.stop
          >
            {{ details }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { Icon } from '~packages/epk-front-shared/ui';

export interface Props {
  id: string;
  details?: string;
  size?: 'm' | 's';
  type?: 'error' | 'warning' | 'success';
  message?: string;
  autoClose?: boolean;
  duration?: number;
}

const props = withDefaults(defineProps<Props>(), {
  details: '',
  size: 'm',
  type: 'warning',
  message: 'Alert',
  autoClose: true,
  duration: 0,
});

const emit = defineEmits<{
  (e: 'close'): void;
}>();

const toastColor = computed(() => {
  switch (props.type) {
    case 'error':
      return { background: '#FCE9E9', color: '#D82222' };
    case 'warning':
      return { background: '#FFF3E5', color: '#E1A815' };
    default:
      return { background: '#E5FFF0', color: '#17AD53' };
  }
});

const isDetailsActive = ref(false);
const detailsRef = ref(null);

onMounted(() => {
  if (props.autoClose) {
    let duration;

    if (props.duration) {
      duration = props.duration;
    } else {
      if (props.type === 'error') {
        duration = 10;
      } else {
        duration = 2;
      }
    }

    setTimeout(() => emit('close'), duration * 1000);
  }
});

const onDetailsClick = () => (isDetailsActive.value = !isDetailsActive.value);

const close = (e: MouseEvent) => {
  const target = e.target as HTMLDivElement;
  if (target?.contains(detailsRef.value)) return;

  emit('close');
};
</script>

<style lang="scss" scoped>
@import './ToastNotification.scss';
</style>
